import React from "react";

const InternshipFillingInstructions = () => {
  return (
    <>
      <div className="mt-2">
        <p>
          {/* <strong>
            Agora Emprega - Competição de Planos de Negócios (CPN) é
            implementada pela Secretaria de Estado da Juventude e Emprego (SEJE)
            através do Instituto Nacional da Juventude (INJ) como parte do
            Programa Emprega, com o apoio do Banco Mundial. O objectivo da CPN é
            facilitar o acesso ao financiamento para Moçambicanas e Moçambicanos
            com idades entre 18 e 35 anos e impulsionar o crescimento económico
            inclusivo. A CPN contempla estágios profissionais nas empresas
            vencedoras, como uma das formas de ajudar a impulsionar o emprego e
            a conectividade entre jovens procurando por seu primeiro emprego ou
            procurando melhorar os seus conhecimentos e habilidades
          </strong> */}
          <h4 className="mt-2">INSTRUÇÕES GERAIS DE PREENCHIMENTO</h4>
          <p>
            1. <strong>Todas as secções</strong> deste formulário devem ser
            preenchidas com informação <strong>correcta e actual</strong> antes
            do envio.
          </p>
          <p>
            2. Ao preencher o formulário de candidatura a estágio, depois de
            concluído,{" "}
            <strong>lembre-se de sempre salvar e proceder ao seu envio</strong>.
          </p>
          <p>
            3. A equipa de implementação da CPN acusará o recebimento deste
            formulário através do endereço de email do candidato apresentado
            neste formulário.
          </p>
          <p>
            4. Ao longo do processo é possível que seja contactado por um
            representante da nossa equipa ou das empresas para as quais tenha
            concorrido, para fornecer informações adicionais sobre a sua
            candidatura a estágio profisisional.
          </p>
          <p>
            5. Por favor,{" "}
            <strong>
              reconfirme que o endereço de e-mail de contato do candidato
              principal e o número de telefone inseridos no formulário estão
              correctos
            </strong>
            .
          </p>
          <p>
            Se o candidato a estágio tiver alguma dúvida sobre a sua
            candidatura, não hesite em nos enviar um e-mail a solicitar
            esclarecimentos através de <strong>agoraemprega@seje.gov.mz</strong>
            . O candidato receberá uma resposta em 36 horas úteis através do
            website. Alternativamente, o candidato pode ligar para a seguinte
            linha de apoio: <strong>85 730 5231 / 87 730 5236</strong>
          </p>
        </p>
      </div>
      <h4 className="mt-2">Critérios de avaliação de candidaturas a estágio</h4>
      <p>
        A sua candidatura a estágio será avaliada obedecendo aos seguintes
        aspectos e ponderadores:
      </p>
      <div>
        <p>
          1. O candidato tem a formação técnica mínima exigida para desempenhar
          com sucesso as tarefas na Vaga a que se candidata; (25%)
        </p>
        <p>
          2. O candidato possui qualificações técnicas adicionais relevante para
          a vaga/posição a que se candidata? (20%)
        </p>
        <p>
          3. O candidato possui a experiência profissional relacionada com
          área/posição a que se candidata (25%)
        </p>
        <p>
          4. O candidato possui proficiência nos idiomas necessários para
          desempenhar com sucesso as actividades na vaga/posição a que se
          candidata? (15%)
        </p>
        <p>
          5. O candidato possui as habilidades sociais, comportamentais e
          atitudes necessárias para desempenhar com sucesso as actividades na
          vaga/posição a que se candidata? (15%)
        </p>
      </div>
    </>
  );
};

export default InternshipFillingInstructions;
